"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPriceDifference = exports.getShowBanner = exports.getTierUpgradeBanner = void 0;
var services_1 = require("@falcon/services");
var SILVER_MONTHLY_DIFF_THRESHOLD = 2.27;
var GOLD_MONTHLY_DIFF_THRESHOLD = 5;
var SILVER_ANNUAL_DIFF_THRESHOLD = 25;
var GOLD_ANNUAL_DIFF_THRESHOLD = 55;
var getTierUpgradeBanner = function (factors) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    if (factors.premiumType === services_1.PREMIUM_TYPE_MONTHLY) {
        var silverPriceDifference = ((_b = (_a = factors.silverPremiums) === null || _a === void 0 ? void 0 : _a.totalMonthlyPremium) !== null && _b !== void 0 ? _b : 0) - ((_d = (_c = factors.bronzePremiums) === null || _c === void 0 ? void 0 : _c.totalMonthlyPremium) !== null && _d !== void 0 ? _d : 0);
        var silverShowBanner = silverPriceDifference < SILVER_MONTHLY_DIFF_THRESHOLD;
        var goldPriceDifference = ((_f = (_e = factors.goldPremiums) === null || _e === void 0 ? void 0 : _e.totalMonthlyPremium) !== null && _f !== void 0 ? _f : 0) - ((_h = (_g = factors.silverPremiums) === null || _g === void 0 ? void 0 : _g.totalMonthlyPremium) !== null && _h !== void 0 ? _h : 0);
        var goldShowBanner = goldPriceDifference < GOLD_MONTHLY_DIFF_THRESHOLD;
        return {
            show: silverShowBanner || goldShowBanner,
            tierData: [
                {
                    tier: services_1.BRONZE_TIER,
                    showBanner: false,
                    priceDifference: ""
                },
                {
                    tier: services_1.SILVER_TIER,
                    showBanner: silverShowBanner,
                    priceDifference: silverPriceDifference.toFixed(2)
                },
                {
                    tier: services_1.GOLD_TIER,
                    showBanner: goldShowBanner,
                    priceDifference: goldPriceDifference.toFixed(2)
                },
            ]
        };
    }
    else {
        var silverPriceDifference = ((_k = (_j = factors.silverPremiums) === null || _j === void 0 ? void 0 : _j.totalAnnualPremium) !== null && _k !== void 0 ? _k : 0) - ((_m = (_l = factors.bronzePremiums) === null || _l === void 0 ? void 0 : _l.totalAnnualPremium) !== null && _m !== void 0 ? _m : 0);
        var silverShowBanner = silverPriceDifference < SILVER_ANNUAL_DIFF_THRESHOLD;
        var goldPriceDifference = ((_p = (_o = factors.goldPremiums) === null || _o === void 0 ? void 0 : _o.totalAnnualPremium) !== null && _p !== void 0 ? _p : 0) - ((_r = (_q = factors.silverPremiums) === null || _q === void 0 ? void 0 : _q.totalAnnualPremium) !== null && _r !== void 0 ? _r : 0);
        var goldShowBanner = goldPriceDifference < GOLD_ANNUAL_DIFF_THRESHOLD;
        return {
            show: silverShowBanner || goldShowBanner,
            tierData: [
                {
                    tier: services_1.BRONZE_TIER,
                    showBanner: false,
                    priceDifference: ""
                },
                {
                    tier: services_1.SILVER_TIER,
                    showBanner: silverShowBanner,
                    priceDifference: silverPriceDifference.toFixed(2)
                },
                {
                    tier: services_1.GOLD_TIER,
                    showBanner: goldShowBanner,
                    priceDifference: goldPriceDifference.toFixed(2)
                },
            ]
        };
    }
};
exports.getTierUpgradeBanner = getTierUpgradeBanner;
var getShowBanner = function (upgradeBanner, tierToRender) {
    return upgradeBanner.tierData
        .find(function (data) { return data.tier === tierToRender; })
        .showBanner;
};
exports.getShowBanner = getShowBanner;
var getPriceDifference = function (upgradeBanner, tierToRender) {
    return upgradeBanner.tierData
        .find(function (data) { return data.tier === tierToRender; })
        .priceDifference;
};
exports.getPriceDifference = getPriceDifference;
//# sourceMappingURL=TierUpgradeBanner.js.map